import { useEffect, useState } from 'react';
import type { PdfConversationData, PdfPayload } from '@nycelogic/nycebuddy-contracts';
import { ImageSourceProvider, PdfConversation, PdfReport } from '@nycelogic/nycebuddy-chat-ui';
import { TranslationProvider } from '@nycelogic/nycebuddy-chat-ui/i18n';
import { client } from '../auth/session';

const isConversation = (d: PdfPayload): d is PdfConversationData => !!(d as PdfConversationData).conversation;

/** `/pdf-export?token=…`: rendered headless by the backend (Playwright waits for `.pdf-content[data-ready="true"]`).
 *  The token carries either one answer or a whole conversation; the page renders whichever it gets. */
export function PdfExport() {
  const token = new URLSearchParams(window.location.search).get('token') ?? '';
  const [data, setData] = useState<PdfPayload | null>(null);
  const [error, setError] = useState<string | null>(null);
  useEffect(() => {
    if (!token) {
      setError('Missing token');
      return;
    }
    client.pdf
      .data(token)
      .then(setData)
      .catch((e: Error) => setError(e.message));
  }, [token]);
  if (error)
    return (
      <div
        className="pdf-content"
        data-ready="true"
        data-error="true"
        style={{ padding: 24, color: '#b42318' }}
      >
        {error}
      </div>
    );
  if (!data) return <div className="pdf-content" data-ready="false" />;
  return (
    <TranslationProvider language="en">
      {/* Pictures in the report are read through the render token: the page has no bearer. */}
      <ImageSourceProvider fetch={(ref) => client.pdf.image(token, ref)}>
        {isConversation(data) ? <PdfConversation data={data} /> : <PdfReport data={data} />}
      </ImageSourceProvider>
    </TranslationProvider>
  );
}
